import { create } from '@thoughtspot/logger';
import { TSToChartEvent, } from '@thoughtspot/ts-chart-sdk';
import { CustomChartError } from '../../../components/chart-error/chart-error.util';
import { ErrorTypes } from '../../../components/chart-error/chart-error.helper';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
const logger = create('context-menu-custom-actions');
export const dispatchContextMenuCustomAction = (commonProps, eventProps) => {
    const { iFrameWindow: iframeRef, appUrl } = commonProps;
    const payload = {
        customAction: eventProps,
    };
    return sendMessage(iframeRef, { eventType: TSToChartEvent.ContextMenuActionClick, payload }, appUrl).then((res) => {
        if (res.data.isValid === true) {
            return '';
        }
        logger.error('Context menu custom action error', res.data.error);
        throw new CustomChartError(ErrorTypes.INVALID_CUSTOM_ACTION_ERROR);
    });
};
//# sourceMappingURL=index.js.map